import type { DisplayText } from "./dto/DisplayText.js"
import es from "./es.js"

/**
 * @description
 *	Dictionary for es-PE locale. Inherits the Spanish base as is, like every
 *	Spanish locale; the base tells why they all read the same.
 */
const esPE: DisplayText = { ...es }

export default esPE
